import { SegmentEventTrackerT } from './types';
import { EventType } from './eventTypes';
import { SegmentAttributes } from './segment-impression';

/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable camelcase */

type SegmentEventPayloadT = {
  deployable_name: string;
  deployable_version: string;
  event_id: string;
} & SegmentAttributes<EventType>;

export const trackViewedImpression: SegmentEventTrackerT<
  SegmentEventPayloadT,
  void
> = (eventType, payload, segmentInstance) => {
  segmentInstance.track(eventType, {
    ...payload,
  });
};
